import React from 'react';
import RoomComponent from "./RoomComponent";
import AboutmeComponent from "./AboutmeComponent";
import GalleryComponent from "./GalleryComponent";
import GiftsComponent from "./GifsComponent";
import AvisComponent from "./AvisComponent";

const gallery1 = [
    {
        img: '/images/cadre.jpg',
        title: 'Cadre de naissance',
    },
    {
        img: '/images/cadre1.jpg',
        title: 'Cadre de naissance',
    },
    {
        img: '/images/cadre2.jpg',
        title: 'Cadre de naissance',
    },
    {
        img: '/images/cadre3.jpg',
        title: 'Cadre de naissance',
    },
    {
        img: '/images/cupcakes.jpg',
        title: 'Cupcakes',
    },
    {
        img: '/images/cupcakes1.jpg',
        title: 'Cupcakes',
    },
    {
        img: '/images/cupcakes2.jpg',
        title: 'Cupcakes',
    },
    {
        img: '/images/cupcakes3.jpg',
        title: 'Cupcakes',
    },
    {
        img: '/images/dreamcatcher.jpg',
        title: 'Attrape-rêves',
    },
    {
        img: '/images/dreamcatcher3.jpg',
        title: 'Attrape-rêves',
    },
    {
        img: '/images/dreamcatcher2.jpg',
        title: 'Attrape-rêves tête de Mickey',
    },
    {
        img: '/images/dreamcatcher1.jpg',
        title: 'Attrape-rêves tête de Mickey',
    },
    {
        img: '/images/lune.jpg',
        title: 'Lune lumineuse',
    },
    {
        img: '/images/lune1.jpg',
        title: 'Lune lumineuse',
    },
    {
        img: '/images/lune2.jpg',
        title: 'Lune lumineuse',
    },
    {
        img: '/images/lune3.jpg',
        title: 'Lune lumineuse',
    }
];

const gallery2 = [
    {
        img: '/images/paquet_cigogne.jpg',
        title: 'Gâteau de couches - paquet cigogne',
        href: 'link'
    },
    {
        img: '/images/paquet_cigogne1.jpg',
        title: 'Gâteau de couches - paquet cigogne',
    },
    {
        img: '/images/paquet_cigogne2.jpg',
        title: 'Gâteau de couches - paquet cigogne',
    },
    {
        img: '/images/paquet_cigogne3.jpg',
        title: 'Gâteau de couches - paquet cigogne',
    },
    {
        img: '/images/gateau_couches.jpg',
        title: 'Attrape-rêves',
    },
    {
        img: '/images/gateau_couches1.jpg',
        title: 'Attrape-rêves',
    },
    {
        img: '/images/gateau_couches2.jpg',
        title: 'Attrape-rêves',
    },
    {
        img: '/images/gateau_couches3.jpg',
        title: 'Attrape-rêves',
    },
    {
        img: '/images/lingettes.jpg',
        title: 'Lingettes et panier',
    },
    {
        img: '/images/lingettes1.jpg',
        title: 'Lingettes et panier',
    },
    {
        img: '/images/lingettes2.jpg',
        title: 'Lingettes et panier',
    },
    {
        img: '/images/lingettes3.jpg',
        title: 'Lingettes et panier',
    }
];

function MainComponent() {
    return (
        <div className="">

            <GalleryComponent images={gallery1} />

            <GiftsComponent/>

            <GalleryComponent images={gallery2} />

            {/*<ContactmeComponent/>*/}

            <RoomComponent/>

            <AvisComponent />

            <AboutmeComponent/>

        </div>

    );
}

export default MainComponent;
